
export const buttonStyle = {
    success: {
      backgroundColor: "#4CAF50", /* Green */
      border: "none",
      color: "white",
      padding: "10px 24px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px",
      fontWeight: 700
    },
    danger: {
      backgroundColor: "red",
      border: "none",
      color: "white",
      padding: "10px 24px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px",
      fontWeight: 700
    }
  }